import { render, staticRenderFns } from "./CartMiniArea.vue?vue&type=template&id=1f2a397a&"
import script from "./CartMiniArea.vue?vue&type=script&lang=ts&"
export * from "./CartMiniArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports